export default {
    state: {
        itemId: 0, // 操作的shapeid
        isMovePosition: false, // 是否主动调整过工具栏位置
        activeFloat: "floatTool", // 配置最高层叠关系
        showFloatTool: false,
        floatToolPosition: {
            left: 0,
            top: 0,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        },
        fontToolType: 0, // 文本工具类型
        conToolType: 0, // 连接线工具类型
        planToolType: 0, // 平面图工具类型
        actionplanToolType: 0, // 路线图工具类型
        specialSetType: "", // 泳道、单元格和矩阵类型
        hasContainerList: false, // 泳道图内是否含有卡片
        floatToolRefresh: false,
        floatToolList: [],
        replaceShapeCache: new Map(), // 通用工具替换形状缓存
        floatToolMoreType: "", // 更多工具类型
        floatToolLock: false,
        // track
        commonTrackFlag: {
            fill: 0,
            line: 0,
            family: 0,
            size: 0,
            addSize: 0,
            reduceSize: 0,
            bold: 0,
            italy: 0,
            underline: 0,
            linethrough: 0,
            align: 0,
            listStyle: 0,
            lineHeight: 0,
            fontAround: 0,
            fontColor: 0,
            fontBgColor: 0,
            replaceShape: 0,
        },
        tableTrackFlag: {
            row: 0,
            col: 0,
            split: 0,
            insertLeft: 0,
            insertRight: 0,
            insertAbove: 0,
            insertBelow: 0,
            delrow: 0,
            delcol: 0,
            delTable: 0,
            merge: 0,
            quick: 0,
        },
    },
    getters: {},
    mutations: {
        setFloatToolState(state, obj) {
            let keys = Object.keys(obj);
            const newItemId = obj.itemId;
            const newShowFloatTool = obj.showFloatTool;

            if (newItemId && newItemId !== state.itemId && newShowFloatTool) {
                state.showFloatTool = false;
            }
            for (let item of keys) {
                state[item] = obj[item];
            }
        },
        setCommonTrackFlag(state, obj) {
            let keys = Object.keys(obj);
            for (let item of keys) {
                state.commonTrackFlag[item] = obj[item];
            }
        },
        setTableTrackFlag(state, obj) {
            let keys = Object.keys(obj);
            for (let item of keys) {
                state.tableTrackFlag[item] = obj[item];
            }
        },
    },
};
